<app-card [id]="'cadastro-tabela-preco'" [title]="'Cadastro de tabelas de preço'">
  <form [formGroup]="cadastroForm" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="form-group col-sm-6">
        <label for="form_nome" class="label-required">Nome</label>
        <input
          id="form_nome"
          [disabled]="loading['registro']"
          type="text"
          class="form-control"
          formControlName="nome"
          maxlength="30"
        />
        <show-errors [control]="cadastroForm.controls.nome"></show-errors>
      </div>

      <div
        class="form-group col-sm-6"
        rem5
        combobox
        [type]="'markups'"
        [loading]="loading"
        [form]="cadastroForm"
        formControlName="markupId"
        toolTipMessage="Adicionar itens com esse markup selecionado, irá somar {{
          somatorioEventosMarkupSelecionado
        }}% do custo no preço."
        (change)="buscarEventosMarkup($event)"
      ></div>
    </div>

    <div class="form-button-row mb-4">
      <button class="btn btn-primary" [disabled]="isLoading">
        <app-loading
          texto="Salvar"
          textoLoading="Salvando"
          [loading]="loading['salvando']"
          icone="ti-save"
        ></app-loading>
      </button>

      <button
        *ngIf="id"
        type="button"
        (click)="excluirTabelaPreco()"
        class="btn btn-danger"
        [disabled]="isLoading"
      >
        <app-loading
          texto="Excluir"
          textoLoading="Excluindo"
          [loading]="loading['excluindo']"
          icone="ti-trash"
        ></app-loading>
      </button>

      <button
        type="button"
        (click)="voltar()"
        class="btn btn-info"
        [disabled]="isLoading"
      >
        <i class="ti ti-back-left"></i> Voltar
      </button>
    </div>

    <div *ngIf="itens.length > 0" class="row">
      <div class="form-group col-sm-12 table-responsive m-0">
        <app-dim-datatable
          [showAcoesMobile]="true"
          [showInfoMobile]="false"
          [rowsOnPage]="10"
          [data]="itens"
          [columns]="colunas"
          [acoes]="true"
          [serverPaginated]="false"
          [totalItems]="itens.length"
          [selectable]="true"
          [selecionados]="selecionados"
          [propSelecionados]="'produtoNome'"
        >
          <ng-template #buttonsMaxTmpl let-row="row" let-index="index">
            <button
              type="button"
              class="btn btn-info btn-mini waves-effect waves-light"
              placement="left"
              ngbTooltip="Detalhar"
              (click)="createViewItem(row)"
              style="border-radius: 10%"
              [disabled]="isLoading || digitacaoItemComponentRef"
            >
              <i class="icofont icofont-info"></i>
            </button>
            <button
              type="button"
              class="btn btn-danger btn-mini waves-effect waves-light"
              placement="left"
              [disabled]="isLoading"
              ngbTooltip="Excluir"
              (click)="removerItem(row)"
              style="border-radius: 10%"
            >
              <i class="ti ti-trash"></i>
            </button>
          </ng-template>
        </app-dim-datatable>
      </div>
    </div>

    <div class="form-button-row mb-4">
      <button
        type="button"
        class="btn btn-info"
        [disabled]="isLoading || digitacaoItemComponentRef"
        (click)="createViewItem()"
      >
        <i class="fa fa-plus"></i>
        Adicionar Item
      </button>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <fieldset>
          <legend>Majoração de Preços</legend>
          <div class="form-radio form-control" style="border: unset; padding-left: 0px">
            <div class="row m-0">
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px; cursor: pointer">
                  <input type="radio" formControlName="majoracao" value="M" />
                  <i class="helper"></i>
                  <span>
                    Recalcular por Markup
                    <i
                      *ngIf="cadastroForm.get('markupId').value"
                      class="ti ti-info-alt mr-2"
                      [ngbTooltip]="
                        'Somatório eventos: ' + somatorioEventosMarkupSelecionado + '%'
                      "
                    ></i>
                  </span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px; cursor: pointer">
                  <input type="radio" formControlName="majoracao" value="P" />
                  <i class="helper"></i><span>Recalcular aplicando margem direta %</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px; cursor: pointer">
                  <input type="radio" formControlName="majoracao" value="V" />
                  <i class="helper"></i><span>Recalcular aplicando valor direto R$</span>
                </label>
              </div>
            </div>
          </div>

          <div *ngIf="cadastroForm.controls.majoracao.value" class="row">
            <div
              *ngIf="cadastroForm.controls.majoracao.value !== 'M'"
              class="form-group col-sm-3"
            >
              <label for="form_majoracao" class="label-required">
                {{ cadastroForm.controls.majoracao.value === 'P' ? '%' : 'R$' }}
                de aumento
              </label>
              <input
                id="form_valorAumento"
                type="text"
                currencyMask
                [options]="{
                  precision: 2,
                  prefix: cadastroForm.controls.majoracao.value === 'V' ? 'R$ ' : '',
                }"
                [attr.min]="cadastroForm.controls.majoracao.value === 'P' ? 0 : null"
                [attr.max]="cadastroForm.controls.majoracao.value === 'P' ? 100 : null"
                inputmode="numeric"
                formControlName="valorAumento"
                class="form-control"
                [class.is-invalid]="
                  cadastroForm.controls.valorAumento.invalid &&
                  cadastroForm.controls.valorAumento.touched
                "
                [readonly]="loading['item']"
              />
              <show-errors [control]="cadastroForm.controls.valorAumento"></show-errors>
            </div>

            <div class="form-group col-sm-3">
              <label for="">&nbsp;</label>
              <button
                type="button"
                class="btn btn-info d-block"
                (click)="aplicarMajoracao()"
              >
                Aplicar
              </button>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </form>
</app-card>

<template #digitacaoItensContainer></template>

<app-abrir-modal #abrirModal></app-abrir-modal>
